"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVBStepper = void 0;
var _react = _interopRequireDefault(require("react"));
var _EditWhite = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Edit-white.svg"));
var _CheckWhite = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Check-white.svg"));
var _ErrorWhite = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Error-white.svg"));
var _chevronDownBlue = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-down-blue.svg"));
var _chevronUpBlue = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-up-blue.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB Stepper as per the design
 */

/**
 * Alternative Step
 * @param {index} - index number to be displayed for each step 
 * @returns Alternative step element with blue background color
 */
const AlternativeStep = _ref => {
  let {
    index
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "stpper-step-number-container stepper-number-blue"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph stepper-step-number-text"
  }, index));
};

/**
 * Error Step
 * @returns Error Step element with red background svg icon
 */
const ErrorStep = () => {
  return /*#__PURE__*/_react.default.createElement("img", {
    src: _ErrorWhite.default
  });
};

/**
 * Check Step
 * @returns Check step element with green background
 */
const CheckStep = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "stpper-step-number-container stepper-number-green"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _CheckWhite.default
  }));
};

/**
 * Edit Step
 * @returns Edit element with orange background
 */
const EditStep = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "stpper-step-number-container stepper-number-orange"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _EditWhite.default
  }));
};

/**
 * Default Step
 * @param {index} : takes a value to display along side step name 
 * @returns Default step with default background color
 */
const DefaultStep = _ref2 => {
  let {
    index
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "stpper-step-number-container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "paragraph stepper-step-number-text"
  }, index));
};

/**
 * All Step presets are grouped here
 * Default
 * Alternative
 * Edit
 * Check
 * Error
 */
const StepNumberVariations = {
  "default": DefaultStep,
  "edit": EditStep,
  "check": CheckStep,
  "error": ErrorStep,
  "alternative": AlternativeStep
};

/**
 * Horizontal Stepper preset
 * @param {*} props - items, uniqueId
 * @returns Horizontal Stepper with selected step variation
 */
const HorizontalStepper = props => {
  var _props$items;
  const items = (_props$items = props === null || props === void 0 ? void 0 : props.items) !== null && _props$items !== void 0 ? _props$items : [];
  const uniqueId = props === null || props === void 0 ? void 0 : props.uniqueId;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "stepper-row-main-container",
    id: uniqueId
  }, items === null || items === void 0 ? void 0 : items.map((item, index) => {
    var _StepNumberVariations, _item$errorMessage;
    const stepPreset = (item === null || item === void 0 ? void 0 : item.stepPreset) || "default";
    const StepNumberVariation = (_StepNumberVariations = StepNumberVariations[stepPreset]) !== null && _StepNumberVariations !== void 0 ? _StepNumberVariations : StepNumberVariations["default"];
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-row-content-container"
    }, /*#__PURE__*/_react.default.createElement(StepNumberVariation, {
      index: ++index
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: stepPreset === "error" ? "stepper-step-name-container stepper-row-error-container" : "stepper-step-name-container"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "".concat(stepPreset === "default" ? "paragraph stepper-row-step-name" : stepPreset === "error" ? "paragraph stepper-row-step-name stepper-name-color-red" : "paragraph stepper-row-step-name stepper-name-color-black")
    }, item === null || item === void 0 ? void 0 : item.title), stepPreset === "error" && /*#__PURE__*/_react.default.createElement("p", {
      className: "paragraph small stepper-name-color-red"
    }, (_item$errorMessage = item === null || item === void 0 ? void 0 : item.errorMessage) !== null && _item$errorMessage !== void 0 ? _item$errorMessage : ""))), index !== (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-row-divider-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-row-divider"
    })));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "stepper-mobile-expanded-container" + " " + uniqueId
  }, items === null || items === void 0 ? void 0 : items.map((item, index) => {
    var _StepNumberVariations2, _item$errorMessage2;
    const stepPreset = (item === null || item === void 0 ? void 0 : item.stepPreset) || "default";
    const StepNumberVariation = (_StepNumberVariations2 = StepNumberVariations[stepPreset]) !== null && _StepNumberVariations2 !== void 0 ? _StepNumberVariations2 : StepNumberVariations["default"];
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "stepper-mobile-column-main-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-mobile-column-content-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: stepPreset === "error" ? "stepper-mobile-column-step-number-divider-container stepper-mobile-margin" : "stepper-mobile-column-step-number-divider-container"
    }, /*#__PURE__*/_react.default.createElement(StepNumberVariation, {
      index: ++index
    }), index !== (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-mobile-column-divider-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-mobile-column-divider"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: stepPreset === "error" ? "stepper-mobile-column-step-name-container" : "stepper-mobile-column-step-name-container"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "paragraph stepper-mobile-column-step-name"
    }, item === null || item === void 0 ? void 0 : item.title), stepPreset === "error" && /*#__PURE__*/_react.default.createElement("p", {
      className: "paragraph stepper-row-step-name"
    }, (_item$errorMessage2 = item === null || item === void 0 ? void 0 : item.errorMessage) !== null && _item$errorMessage2 !== void 0 ? _item$errorMessage2 : ""))));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "stepper-icon-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "stepper_dropdown",
    className: "stepper-icon-content"
  }, /*#__PURE__*/_react.default.createElement("img", {
    id: uniqueId,
    src: _chevronDownBlue.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    id: "stepper_up",
    className: "stepper-icon-content stepper-disable-icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    id: uniqueId,
    src: _chevronUpBlue.default
  })), /*#__PURE__*/_react.default.createElement("hr", null)));
};

/**
 * Vertical Stepper preset
 * @param {*} props - items, uniqueId
 * @returns Vertical Stepper with selected step variation
 */
const VerticalStepper = props => {
  var _props$items2;
  const items = (_props$items2 = props === null || props === void 0 ? void 0 : props.items) !== null && _props$items2 !== void 0 ? _props$items2 : [];
  const uniqueId = props === null || props === void 0 ? void 0 : props.uniqueId;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "stepper-column-main-container",
    id: uniqueId
  }, items === null || items === void 0 ? void 0 : items.map((item, index) => {
    var _StepNumberVariations3, _item$errorMessage3;
    const stepPreset = (item === null || item === void 0 ? void 0 : item.stepPreset) || "default";
    const StepNumberVariation = (_StepNumberVariations3 = StepNumberVariations[stepPreset]) !== null && _StepNumberVariations3 !== void 0 ? _StepNumberVariations3 : StepNumberVariations["default"];
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "stepper-column-content-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-column-step-number-divider-container"
    }, /*#__PURE__*/_react.default.createElement(StepNumberVariation, {
      index: ++index
    }), index !== (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-column-divider-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-column-divider"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-column-step-name-container"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "paragraph stepper-column-step-name"
    }, item === null || item === void 0 ? void 0 : item.title), stepPreset === "error" && /*#__PURE__*/_react.default.createElement("p", {
      className: "paragraph stepper-row-step-name"
    }, (_item$errorMessage3 = item === null || item === void 0 ? void 0 : item.errorMessage) !== null && _item$errorMessage3 !== void 0 ? _item$errorMessage3 : "")));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "stepper-mobile-expanded-container" + " " + uniqueId
  }, items === null || items === void 0 ? void 0 : items.map((item, index) => {
    var _StepNumberVariations4, _item$errorMessage4;
    const stepPreset = (item === null || item === void 0 ? void 0 : item.stepPreset) || "default";
    const StepNumberVariation = (_StepNumberVariations4 = StepNumberVariations[stepPreset]) !== null && _StepNumberVariations4 !== void 0 ? _StepNumberVariations4 : StepNumberVariations["default"];
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "stepper-mobile-column-main-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-mobile-column-content-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: stepPreset === "error" ? "stepper-mobile-column-step-number-divider-container stepper-mobile-margin" : "stepper-mobile-column-step-number-divider-container"
    }, /*#__PURE__*/_react.default.createElement(StepNumberVariation, {
      index: ++index
    }), index !== (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-mobile-column-divider-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "stepper-mobile-column-divider"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: stepPreset === "error" ? "stepper-mobile-column-step-name-container" : "stepper-mobile-column-step-name-container"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "paragraph stepper-mobile-column-step-name"
    }, item === null || item === void 0 ? void 0 : item.title), stepPreset === "error" && /*#__PURE__*/_react.default.createElement("p", {
      className: "paragraph stepper-row-step-name"
    }, (_item$errorMessage4 = item === null || item === void 0 ? void 0 : item.errorMessage) !== null && _item$errorMessage4 !== void 0 ? _item$errorMessage4 : ""))));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "stepper-icon-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "stepper_dropdown",
    className: "stepper-icon-content"
  }, /*#__PURE__*/_react.default.createElement("img", {
    id: uniqueId,
    src: _chevronDownBlue.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    id: "stepper_up",
    className: "stepper-icon-content stepper-disable-icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    id: uniqueId,
    src: _chevronUpBlue.default
  })), /*#__PURE__*/_react.default.createElement("hr", null)));
};

/**
 * All stepper variations are grouped here
 * Vertical Stepper
 * Horizontal Stepper
 */
const StepperVariations = {
  "vertical": VerticalStepper,
  "horizontal": HorizontalStepper
};

/**
  * SVBStepper
  * see ../readme.MD for sample body
  * @param preset: to render horizontal or vertical stepper(horizontal|vertical) [required]
  * @param stepPreset: to render different types of stepPreset(default|alternative|edit|check|error) [required]
  * @param items: to render the step names, default data type is array of strings(array of objects for error type) [required]
  * @param uniqueId: to uniquely identify each stepper which is helpful during mobile transition [optional]
  * @returns stepper HTML with content
  */
const SVBStepper = props => {
  var _StepperVariations$pr;
  const preset = (props === null || props === void 0 ? void 0 : props.preset) || "vertical";
  const StepperVariation = (_StepperVariations$pr = StepperVariations[preset]) !== null && _StepperVariations$pr !== void 0 ? _StepperVariations$pr : StepperVariations["vertical"];
  return /*#__PURE__*/_react.default.createElement(StepperVariation, props);
};
exports.SVBStepper = SVBStepper;